module.exports = __webpack_public_path__ + "static/sabela-garcia-cuesta-a83daedb8802dd02d60e2f63715e6598.png";